/* keyedalike.com — collection and search filters (sections/ka-collection-grid.liquid, ka-search-grid.liquid).
   Progressive enhancement only: the filters are a plain GET form in a <details>, and everything works without this
   file.
   - Above 1100 the filters are an always-open sidebar: any checkbox change submits the form.
   - At ≤1100 the filters are a drawer: it starts closed, and at ≤860 its groups start collapsed (the mockup's script
     did the same on load). That first state is set by the inline script right after
     the drawer (snippets/ka-facets.liquid), before the first paint: this file is deferred and used to set it after
     the first paint, which moved everything under the drawer (a CLS of 0.19 on phones). "Show models" (or "Show
     results") submits; with no filter on, "Clear all" is the form's reset button and needs nothing here (a reset
     fires no change event).
   - Crossing 1100 opens the sidebar again when the window widens (the mockup left it closed with no summary to
     reopen it, README §10) and closes the drawer when it narrows.
   - Changing the sort submits the same form, so the sort, the filters and the active colour travel together. */
(() => {
  const wide = window.matchMedia('(min-width: 1101px)');
  const submit = (form) => (form.requestSubmit ? form.requestSubmit() : form.submit());

  document.querySelectorAll('form[data-ka-facets]').forEach((form) => {
    const drawer = form.querySelector('[data-ka-drawer]');
    const sort = document.querySelector(`select[data-ka-sort][form="${form.id}"]`);

    if (drawer) {
      wide.addEventListener('change', (event) => { drawer.open = event.matches; });
      form.addEventListener('change', (event) => {
        if (wide.matches && event.target.matches('input[type="checkbox"]')) submit(form);
      });
    }
    if (sort) sort.addEventListener('change', () => submit(form));
  });
})();
